import actionTypes from "../actionTypes";

// UTILS
import * as odberneMiestaUtils from "../../utils/odberneMiesta/odberneMiestaUtils";

// ACTIONS
import * as spotrebyActions from "../spotreba/spotrebyActions";

export const updateCustomFiltersOM = ({ customFilters }) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_CUSTOM_FILTERS_OM,
      customFilters,
    });
  };
};

// SUPPORT METHODS
const buildCustomFilters = (field, operator, value) => [
  { field, operator, value },
];

// UPDATE DATA
const updateSpotrebaGraf = async (dispatch, chartProps) => {
  const action = spotrebyActions.getSpotreba;
  await dispatch(action(chartProps));
};

export const changeOM = (
  { OM, grids },
  isPickedByDoubleClickInGridRow = false
) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_OM,
      data: OM,
      isPickedByDoubleClickInGridRow,
    });

    if (OM?.I_ZIS_OM) {
      const { I_ZIS_OM, NAZOV } = OM;
      const customFilters = buildCustomFilters("I_ZIS_OM", "eq", I_ZIS_OM);

      // GRAFY
      await updateSpotrebaGraf(dispatch, { NAZOV_OM: NAZOV, customFilters });
    }
  };
};

const getOMRequest = () => ({
  type: actionTypes.GET_OM_REQUEST,
});
const getOMSuccess = (res) => ({
  type: actionTypes.GET_OM_SUCCESS,
  res,
});
const getOMFailure = (error) => ({
  type: actionTypes.GET_OM_FAILURE,
  error,
});

export const getOM = (id) => {
  return async (dispatch) => {
    try {
      dispatch(getOMRequest());
      let res = await odberneMiestaUtils.getOM(id);
      dispatch(getOMSuccess(res));
    } catch (error) {
      dispatch(getOMFailure(error));
    }
  };
};

const getListOMRequest = () => ({
  type: actionTypes.GET_LIST_OM_REQUEST,
});
const getListOMSuccess = (
  res,
  gridFilter,
  gridSort,
  gridPage,
  customFilters
) => ({
  type: actionTypes.GET_LIST_OM_SUCCESS,
  gridFilter,
  gridSort,
  gridPage,
  customFilters,
  res,
});
const getListOMFailure = (error) => ({
  type: actionTypes.GET_LIST_OM_FAILURE,
  error,
});
export const getListOM = ({
  gridFilter,
  gridSort,
  gridPage,
  customFilters,
}) => {
  return async (dispatch) => {
    try {
      dispatch(getListOMRequest());

      const filter = { filters: [...gridFilter.filters, ...customFilters] };
      let res = await odberneMiestaUtils.getListOM(filter, gridSort, gridPage);

      dispatch(
        getListOMSuccess(res, gridFilter, gridSort, gridPage, customFilters)
      );
    } catch (error) {
      dispatch(getListOMFailure(error));
    }
  };
};
